import adminApi from "services/admin-api";

export const workspaceSchoolService = {
  galleryItems: {
    createPlayer: adminApi.galleryItems.createPlayer,
    createSchool: adminApi.galleryItems.createSchool,
    createSchoolTeam: adminApi.galleryItems.createSchoolTeam,
    listSchool: adminApi.galleryItems.listSchool,
    listSchoolTeam: adminApi.galleryItems.listSchoolTeam,
    remove: adminApi.galleryItems.remove,
    update: adminApi.galleryItems.update,
  },
  schoolDashboards: {
    get: adminApi.schoolDashboards.get,
  },
  schoolDocuments: {
    create: adminApi.schoolDocuments.create,
    list: adminApi.schoolDocuments.list,
    remove: adminApi.schoolDocuments.remove,
    update: adminApi.schoolDocuments.update,
    verify: adminApi.schoolDocuments.verify,
  },
  schoolMatches: {
    create: adminApi.schoolMatches.create,
    get: adminApi.schoolMatches.get,
    list: adminApi.schoolMatches.list,
    update: adminApi.schoolMatches.update,
  },
  schoolMatchLiveEvents: {
    create: adminApi.schoolMatchLiveEvents.create,
    list: adminApi.schoolMatchLiveEvents.list,
    update: adminApi.schoolMatchLiveEvents.update,
  },
  schoolMatchScoresheets: {
    get: adminApi.schoolMatchScoresheets.get,
    save: adminApi.schoolMatchScoresheets.save,
    update: adminApi.schoolMatchScoresheets.update,
  },
  schoolPlayers: {
    create: adminApi.schoolPlayers.create,
    get: adminApi.schoolPlayers.get,
    list: adminApi.schoolPlayers.list,
    remove: adminApi.schoolPlayers.remove,
    update: adminApi.schoolPlayers.update,
  },
  schoolRoles: {
    create: adminApi.schoolRoles.create,
    list: adminApi.schoolRoles.list,
    listCandidates: adminApi.schoolRoles.listCandidates,
    remove: adminApi.schoolRoles.remove,
    update: adminApi.schoolRoles.update,
  },
  schoolRosters: {
    create: adminApi.schoolRosters.create,
    get: adminApi.schoolRosters.get,
    list: adminApi.schoolRosters.list,
    update: adminApi.schoolRosters.update,
  },
  schools: {
    create: adminApi.schools.create,
    get: adminApi.schools.get,
    list: adminApi.schools.list,
    update: adminApi.schools.update,
  },
  schoolSports: {
    create: adminApi.schoolSports.create,
    list: adminApi.schoolSports.list,
    update: adminApi.schoolSports.update,
  },
  schoolTeams: {
    create: adminApi.schoolTeams.create,
    get: adminApi.schoolTeams.get,
    list: adminApi.schoolTeams.list,
    remove: adminApi.schoolTeams.remove,
    update: adminApi.schoolTeams.update,
  },
  schoolTeamDashboards: {
    get: adminApi.schoolTeamDashboards.get,
  },
  schoolTeamPlayers: {
    create: adminApi.schoolTeamPlayers.create,
    list: adminApi.schoolTeamPlayers.list,
  },
};
